import { stringify } from "../../util/querystring-util";
import { restResourceRequester } from "../rest-resource-requester";
import { GetComponentRequest } from "./get-component/GetComponentRequest";
import { GetComponentResponse } from "./get-component/GetComponentResponse";
import { CreateComponentRequest } from "./create-component/CreateComponentRequest";
import { CreateComponentResponse } from "./create-component/CreateComponentResponse";
import { UpdateComponentRequest } from "./update-component/UpdateComponentRequest";
import { UpdateComponentResponse } from "./update-component/UpdateComponentResponse";
import { UpdateComponentAttributesRequest } from "./update-component-attributes/UpdateComponentAttributesRequest";
import { UpdateComponentAttributesResponse } from "./update-component-attributes/UpdateComponentAttributesResponse";

interface ComponentRestResource {
  getComponent(request: GetComponentRequest): Promise<GetComponentResponse>;
  createComponent(
    request: CreateComponentRequest,
  ): Promise<CreateComponentResponse>;
  updateComponent(
    request: UpdateComponentRequest,
  ): Promise<UpdateComponentResponse>;
  updateComponentAttributes(
    request: UpdateComponentAttributesRequest,
  ): Promise<UpdateComponentAttributesResponse>;
}

const REST_RESOURCE_NAME = "/component";

/**
 * GET /component/{rootComponentId}/{componentId}
 */
const getComponent = restResourceRequester<
  GetComponentRequest,
  GetComponentResponse
>("GET", (request) => {
  const queryParameters = {
    dipByRgn: request.dipByRgn,
    godFlg: request.godFlg,
  };
  return `${REST_RESOURCE_NAME}/${request.rootComponentId}/${
    request.componentId
  }?${stringify(queryParameters)}`;
});

/**
 * PUT /component
 */
const createComponent = restResourceRequester<
  CreateComponentRequest,
  CreateComponentResponse
>(
  "PUT",
  (request) => {
    return `${REST_RESOURCE_NAME}`;
  },
  (request) => JSON.stringify(request),
);

/**
 * PUT /component/{componentId}
 */
const updateComponent = restResourceRequester<
  UpdateComponentRequest,
  UpdateComponentResponse
>(
  "PUT",
  (request) => {
    return `${REST_RESOURCE_NAME}/${request.cpntId}`;
  },
  (request) => JSON.stringify(request),
);

/**
 * PUT /components/{componentId}/attributes
 */
const updateComponentAttributes = restResourceRequester<
  UpdateComponentAttributesRequest,
  UpdateComponentAttributesResponse
>(
  "PUT",
  (request) => {
    return `${REST_RESOURCE_NAME}/${request.cpntId}/attributes`;
  },
  (request) => JSON.stringify(request),
);

export const componentRestResource: ComponentRestResource = {
  getComponent: getComponent,
  createComponent: createComponent,
  updateComponent: updateComponent,
  updateComponentAttributes: updateComponentAttributes,
};
